// Annotation Portal React UI for Manage Super_Admin

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SamplesInfo from "layouts/annotator/samples/modals/SamplesInfo";
import SamplesDataTable from "layouts/annotator/samples/data/SamplesDataTable";
import { getSamples, getStateSampleCount } from "services/sampleService";

function ManageSuper_Admin() {
  const [OpenSampleInfo, setOpenSampleInfo] = useState(false);
  const [sampleList, setSampleData] = useState([]);
  const [sampleCount, setSampleCount] = useState({});
  const annotatorId = "4e1483b1-8498-4fde-add7-3ea03613cb71";
  const state = "Maharashtra";

  const defaultFilters = {
    state: state,
    status: "",
    annotator: annotatorId,
    village: "",
    discrepancy: "",
    language: "",
    page: 1,
    limit: 100,
  };

  const fetchSamples = async (filters) => {
    const data = await getSamples(filters);
    setSampleData(data);
  };

  const fetchSampleCount = async () => {
    const data = await getStateSampleCount(state);
    console.log(data);
    setSampleCount(data);
  };

  /* useEffect hook call when component get mount */
  useEffect(() => {
    fetchSamples(defaultFilters);
    fetchSampleCount();
  }, []);

  const navigate = useNavigate();
  const handleEdit = (sampleId) => {
    navigate(`/sample_details/${sampleId}`);
  };
  const { columns, rows } = SamplesDataTable({ samples: sampleList, onEdit: handleEdit });

  // Called when user clicks "Filter" button in SampleInfo
  const handleFilterSubmit = (newFilters) => {
    fetchSamples(newFilters);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SamplesInfo
              open={OpenSampleInfo}
              onClose={() => setOpenSampleInfo(false)}
              onFilterSubmit={handleFilterSubmit}
              sampleCounts={sampleCount}
            />
            <MDBox pt={3} pb={3}>
              <Card
                sx={{
                  boxShadow: 4,
                  borderRadius: 2,
                  overflow: "hidden",
                  backgroundColor: "#f9fafe",
                  border: "1px solid #e0e0e0",
                }}
              >
                <MDBox>
                  {sampleList.length > 0 && (
                    <DataTable
                      key={`datatable-${sampleList.length}`} // forces a remount
                      table={{ columns, rows }}
                      isSorted={true}
                      entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 25] }}
                      showTotalEntries={true}
                      canSearch={true}
                      pagination={{ variant: "gradient", color: "info" }}
                      noEndBorder={false}
                    />
                  )}
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ManageSuper_Admin;
